import styled, { css } from "styled-components";

import Checkbox from "../../Checkbox/styled";
import Props from "./props";

const Item = styled.li<Props>`
    cursor: pointer;
    user-select: none;
    position: relative;
    span {
        padding: 1rem 1.5rem 1rem 3rem;
        display: inline-block;
        border-radius: 0rem 3rem 3rem 0rem;
        transition: background-color 0.3s ease;
        &:hover {
            background-color: ${props => props.theme.colors.black(0.1)};
        }
        ${({ isSubLevel }) =>
            isSubLevel &&
            css`
                padding-left: 5rem;
            `}
    }
    ${Checkbox} {
        top: 0.9rem;
    }
`;

export default Item;
